// extracted by mini-css-extract-plugin
export var breadcrumb = "all-reviews-module--breadcrumb--1d311";
export var cardContainer = "all-reviews-module--cardContainer--b6f21";
export var cardContent = "all-reviews-module--cardContent--1f900";
export var cardDescription = "all-reviews-module--cardDescription--fcf23";
export var cardImage = "all-reviews-module--cardImage--0a60c";
export var cardSubtitle = "all-reviews-module--cardSubtitle--200ea";
export var genericContainer = "all-reviews-module--genericContainer--7ecac";
export var gridContainer = "all-reviews-module--gridContainer--29d64";
export var gridStaticContainer = "all-reviews-module--gridStaticContainer--e52f3";
export var lastSection = "all-reviews-module--lastSection--25436";
export var reviewsContainer = "all-reviews-module--reviewsContainer--8131b";
export var title = "all-reviews-module--title--edf27";
export var titleContainer = "all-reviews-module--titleContainer--c2319";
export var underline = "all-reviews-module--underline--6b4ff";
export var wrapperList = "all-reviews-module--wrapperList--cb1ff";